import * as React from "react";
import "./login.scss";
import * as microsoftTeams from "@microsoft/teams-js";
import { Helper } from '../../Utils/Helper';
export interface Iprops {
    appurl:String;
    email:String;
    clientid:String;
}
export default class Login extends React.Component<Iprops,{}> {
  public state={authenticaiotnbuttonclicked:false};
  public render() {
    if(this.state.authenticaiotnbuttonclicked){
      return (
        <div  
          className="text-center"
          style={{
            backgroundColor: "#fff",
            color: "black",
            padding: "20px"
          }}>
              Please refresh the tab.
        </div>
      );
    }
    return (
      <div id="clientauthentication3">
        <div className="section">
          <div
            className="text-center "
            style={{
              backgroundColor: "#0078D7",
              color: "#fff",
              padding: "15px"
            }}
          >
            IMPORTANT!
          </div>
        </div>
        <div style={{maxWidth: '650px',margin: '0 auto'}}>
          <div className="section">
          <div className="text-center">
            <b>MIPA</b> follows the security requirements set by Microsoft for
            Office 365 Add-ins.{" "}
            <b>
              An Office 365 Global Administrator must be the first to activate
              the Add-in by authorizing and giving the organization proper
              consent.
            </b>
          </div>
        </div>
        <div className="text-center section">
          <button
            id="btnopenwindowWithconsent"
            className="btn btn-primary btn-sm dynamictext"
            onClick={()=> {this.Authenticate(true);}}
          >
            Office 365 Admin=&gt; Click to authorize and give consent
          </button>
        </div>
         <div className="section">
          If your administrator has activated the add-in; you are ready to go
        </div>
        <div className="text-center">
          <button 
            style={{margin:'20px'}}
            id="btnopenwindow"
            className="btn btn-primary btn-sm dynamictext"
            onClick={()=> {this.Authenticate(false);}}
          >
            Connect as a user
          </button>
        </div>
        <div className="section dynamictext" style={{ margin: "10px 0" }}>
          Feel free to contact us, support@iglobe.dk we are ready to assit you.
        </div>
        <div className="section">
          <div
            className="dynamictext"
            style={{ fontWeight: "bold", marginBottom: "10px" }}
          >
            Privacy policy
          </div>
          <div className="dynamictext" data-html="privacymessage">
            Protecting the security and privacy of your personal data is
            important to iGlobe. Therefore, iGlobe processes personal data in
            compliance with applicable laws on data protection and data
            security. By activating this Add-in I agree {" "}
            <a
              href="https://mipa.iglobe.dk/EULA"
              target="_blank"
            >
              to the terms of use MIPA
            </a>{" "}
            and {" "}
            <a href="https://instassl.iglobecrm.com/legal-information" target="_blank">
              privacy policy of iGlobe
            </a>
          </div>
        </div>
        </div>
      </div>
    );
  }
  public Authenticate=(consent)=> {
    let url = "https://login.microsoftonline.com/common/oauth2/authorize";  
    let redirect=this.props.appurl.substr(0,this.props.appurl.lastIndexOf('/'))+'/Auth';       
    redirect =encodeURIComponent(redirect) + "&state=1|"+this.props.email+"|"+Helper.GetSecurityId();
    url += "?IsDlg=1&client_id=" + this.props.clientid + "&scope=Web.Read List.Manage&response_type=code&redirect_uri=";
    url += redirect;
    if(consent===true) {
    url +='&prompt=admin_consent';
    }
    
    var successCallback=(data)=> {
       window.location.reload();
       microsoftTeams.authentication.notifySuccess();
    };
    var failureCallback=(error)=> {
        microsoftTeams.authentication.notifyFailure();
    };
    microsoftTeams.authentication.authenticate({url: url, 
        width: 400, 
        height: 700,
        successCallback: successCallback,
        failureCallback: failureCallback
    });
    this.setState({authenticaiotnbuttonclicked:true});
  }
}
